/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : NonMSACustomerPO.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422336
*
* @Date         : Sep 14, 2020
*
* @Version      : Version 1.0
*
* By            : H422336
* On             : Sep 16,2020
* Description    : ASDS-2744 UI Enhancements Phase-II
*
* By            : H422336
* On            : Sep 23, 2020
* Description   : ASDS - 3020 - UI Enhancements for Phase - II
*
* By            : H422337
* On            : Sep 25, 2020
* Description   : ASDS - 3225- Bug fixes for Phase - II
*
* By            : H422336
* On            : Sep 29, 2020
* Description   : ASDS - 3233 UI Enhancements for Phase - II
*
* By             : H422336
* On             : Oct 06,2020
* Description    : ASDS-3227 APU enhancements as part of phase-2
*
* By            : H422336
* On            : Oct 05, 2020
* Description   : ASDS - 3496 Bugfix UI Enhancements for Phase - II
*
*
* By             : H422336
* On             : Oct 08,2020
* Description    : ASDS-3515 APU enhancements as part of phase-2 bugfix
*
* By            : H422337
* On            : Oct 13, 2020
* Description   : ASDS - 3626 UI Enhancements for Phase - II
*
* By            : H422337
* On            : Nov 18, 2020
* Description   : ASDS - 4073 - selection checkbox bug fixes - Phase-2

******************************************************************************/
import * as React from 'react';
import '@scuf/common/honeywell/theme.css';
import { connect } from 'react-redux';
import './ConfigureAPU.css';
import { DataTable } from '@scuf/datatable';
import { Grid, Input, Notification } from '@scuf/common';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import { Icon, Select } from '@scuf/common';
import Item from '@scuf/datatable/dist/components/DataTable/ActionBar/Item/Item';
import { InLineLoader } from '../Loader/Loader';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';
import { ApuErrorLabels, CheckoutUILabels } from '../constants/checkout-constants';
import { ContactUsMessage } from '../Common/ContactUsMessage';

interface INonMSACustomerPO {
    productId: string;
    productData: ICustomerPOData[];
    isProductFetching: boolean;
    isProductFetchSuccess: boolean;
    showAPUValidationErrorMsg: boolean;
    purchaseOrders: any;
    featuresMasterData: any;
    isPODataFetching: boolean;
    isPODataSuccess: boolean;

    deleteRow: Function;
    addNewRow: Function;
    updateSerial: Function;
    updateAircraftOem: Function;
    updatePurchaseType: Function;
    getPurchaseOrderDetails: Function;
    updatePurchaseOrderNo: Function;
    hideAPUValidationErrMsg: Function;
    getSubProductDetails: Function;
}

interface ICustomerPOData {
    acOem: string;
    oemError: string;
    serialNumber: string;
    serialNumberError: string;
    purchaseOrderNumber: string;
    purchaseOrderNumberError: string;
    expiryDate: string;
    unitPrice: number;
    subProductId: string;
}

class NonMSACustomerPO extends React.Component<INonMSACustomerPO, any> {
    constructor(props) {
        super(props);

        this.state = {
            selectedRowData: [],
            errorRowData: [],
        };

        this.handleRetry = this.handleRetry.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
    }

    updateSerialNumber(newVal: any, cellData: ICellData): void {
        this.updateSelectedRowData(cellData);
        this.props.hideAPUValidationErrMsg(true);
        if (cellData.field === 'serialNumber') {
            this.props.updateSerial(newVal, cellData.rowIndex);
        }
        this.props.hideAPUValidationErrMsg(true);
    }
    updatePurchaseOrderNumber(newVal: any, cellData: ICellData): void {
        this.updateSelectedRowData(cellData);
        this.props.updatePurchaseOrderNo(newVal, cellData.rowIndex);
        this.props.hideAPUValidationErrMsg(true);
    }
    deleteMultipleItems() {
        this.props.deleteRow(this.state.selectedRowData);
        this.setState({ selectedRowData: [] });
    }
    addAPUMultipleRow(): void {
        this.props.addNewRow(0);
        this.props.hideAPUValidationErrMsg(true);
    }
    poNumberRenderer(cellData: ICellData): JSX.Element {
        return (
            <React.Fragment>
                <Select
                className="contract-number-dropdown"
                    key={cellData.rowIndex}
                    placeholder="Enter or Select Customer PO"
                    value={cellData.rowData.purchaseOrderNumber}
                    search={true}
                    onChange={(value: any) => { this.updatePurchaseOrderNumber(value, cellData); }}
                    options={this.props.purchaseOrders}
                />
            </React.Fragment>
        );
    }
    unitPriceRenderer(cellData: ICellData) {
        return <span>{`$${cellData.value.toFixed(2)}`}</span>;
    }

    handleRetry() {
        if (!this.props.isProductFetching && !this.props.isProductFetchSuccess) {
            this.props.getSubProductDetails(this.props.productId);
        }
        if (!this.props.isPODataFetching && !this.props.isPODataSuccess) {
            this.props.getSubProductDetails(this.props.productId);
            this.props.getPurchaseOrderDetails();
        }
    }

    componentDidMount() {
        this.props.getPurchaseOrderDetails();
    }

    rowExpansionTemplate(data: any){
        let errorMsg: string = '';
        let errorTitle: string = '';

        if (data.purchaseOrderNumberError !== '') {
            errorMsg = data.purchaseOrderNumberError;
            if (errorMsg === ApuErrorLabels.NONMSA_PURCHASE_ORDER_ERROR) {
                errorTitle = ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR;
            }

            if (errorMsg === ApuErrorLabels.NONMSA_PURCHASE_ORDER_QUANTITY_ERROR) {
                errorTitle = ApuErrorLabels.NONMSA_PURCHASE_ORDER_QUANTITY_ERROR_TITLE;
            }
        }
        if (data.serialNumberError !== '') {
            errorMsg = data.serialNumberError;
            if (errorMsg === ApuErrorLabels.MSA_SERIAL_ERROR_EMPTY) {
                errorTitle = ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR;
            } else if (errorMsg === ApuErrorLabels.MSA_SERIAL_ERROR_INVALID) {
                errorTitle = ApuErrorLabels.SERIAL_NUMBER_INVALID;
            } else {
                errorTitle = ApuErrorLabels.SERIAL_NUMBER_DUBLICATE;
            }
        }
        if (this.props.showAPUValidationErrorMsg) {
            if (errorTitle === ApuErrorLabels.ALL_FIELDS_EMPTY_ERROR ) {
                return  <Notification hasIcon={true} severity="important"  title={errorTitle} style={{margin: 0}} onCloseClick={() => {this.props.hideAPUValidationErrMsg(false); }} >{errorMsg}</Notification>;
            } else {
                return  <Notification hasIcon={true} severity="critical"  title={errorTitle} style={{margin: 0}} onCloseClick={() => {this.props.hideAPUValidationErrMsg(false); }}  >{errorMsg}</Notification>;
            }
        } else {
           return ;
       }
    }
    updateSelectedRowData(cellData: ICellData) {
        if (this.state.selectedRowData.length !== 0) {
            const indexFromSelectedRowData = this.state.selectedRowData.findIndex((x: any) => (x.purchaseOrderNumber === cellData.rowData.purchaseOrderNumber) && (x.serialNumber === cellData.rowData.serialNumber));
            if (indexFromSelectedRowData !== -1) {
                    let  selecedData = [...this.state.selectedRowData];
                    selecedData.splice(indexFromSelectedRowData, 1);
                    this.setState({selectedRowData: selecedData});
            }
        }
  }


    render() {
        let ErrorRowData = this.props.productData.filter((product: any) => {
            if (typeof product.validInputData !== 'undefined' && !product.validInputData && (product.serialNumberError !== '' || product.purchaseOrderNumberError !== '')) {
                return product;
            }
        });
        return (
            <div>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={12}>
                            { (this.props.isPODataFetching || this.props.isProductFetching) &&
                                <InLineLoader text="Loading Customer PO Details" loading={true} overlayColor="transparent" inlineclassname="msa-configure-loader">
                                </InLineLoader>
                            }
                            {(!this.props.isPODataFetching && !this.props.isProductFetching) && (!this.props.isPODataSuccess || !this.props.isProductFetchSuccess) &&
                                <Notification
                                    hasIcon={true}
                                    title={'There is an error in processing your request.'}
                                    severity="critical"
                                    detailsText="Retry"
                                    onDetailsClick={this.handleRetry}
                                />
                            }
                            {!this.props.isPODataFetching && !this.props.isProductFetching && this.props.isPODataSuccess  && this.props.purchaseOrders !== '' && this.props.purchaseOrders.length === 0 &&
                        <Notification
                            hasIcon={true}
                            title={'No Purchase Orders found'}
                            severity="critical"
                        >
                            <ContactUsMessage>{CheckoutUILabels.NO_PURCHASE_ORDER_ERROR}</ContactUsMessage>
                        </Notification>
                    }
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                {(!this.props.isPODataFetching && this.props.isPODataSuccess) && (!this.props.isProductFetching && this.props.isProductFetchSuccess) && (this.props.purchaseOrders.length !== 0 && this.props.purchaseOrders[0].value !== '') &&
                    <React.Fragment>
                        <p className="data-table-heading">Add Details for key with Customer PO</p>
                        <DataTable
                            data={this.props.productData}
                            onEdit={(newVal: any, cellData: ICellData) => this.updateSerialNumber(newVal, cellData)}
                            selectionMode="multiple"
                            selection={this.state.selectedRowData}
                            onSelectionChange={(e) => {
                                this.setState({ selectedRowData: e });
                            }}
                            expandedRows={ ErrorRowData }
                            rowExpansionTemplate={this.rowExpansionTemplate}
                        >
                            <DataTable.HeaderBar>
                                    <DataTable.HeaderBar.Item
                                        content="Add"
                                        iconSize="small"
                                        icon="slidercontrols-plus"
                                        onClick={() => this.addAPUMultipleRow()}
                                    />
                            </DataTable.HeaderBar>
                            <DataTable.ActionBar>
                                <Item
                                    icon={<Icon name="delete" root="common" size="small" />}
                                    content="Delete"
                                    onClick={() => this.deleteMultipleItems()}
                                />
                            </DataTable.ActionBar>
                            <DataTable.Column field="serialNumber" header="APU Serial No." align="left" placeholder="Enter Serial No." renderer={(cellData) =>this.serialNumberRenderer(cellData)}/>
                            <DataTable.Column field="purchaseOrderNumber" header="Customer Purchase Order" align="left" renderer={(cellData) => this.poNumberRenderer(cellData)} />
                            <DataTable.Column field="unitPrice" header="Unit Price" align="left" editable={false} renderer={this.unitPriceRenderer}/>
                        </DataTable>
                    </React.Fragment>}
            </div>
        );
    }
    serialNumberRenderer(cellData: ICellData) {


        return (
            <Input placeholder="Enter serial number" disabled={false} type="string" className="po datatable-text-input" fluid={true} value={cellData.rowData.serialNumber} onChange={(newVal: string) => this.updateSerialNumber(newVal, cellData)} />
        );
    }
}

const mapDispatchToProps = {
    addNewRow: ConfigureAPUActions.addNewRow,
    deleteRow: ConfigureAPUActions.deleteRow,
    updateSerial: ConfigureAPUActions.updateSerial,
    updateAircraftOem: ConfigureAPUActions.updateAircraftOem,
    updatePurchaseType: ConfigureAPUActions.updatePurchaseType,
    getPurchaseOrderDetails: ConfigureAPUActions.getPurchaseOrderDetails,
    updatePurchaseOrderNo: ConfigureAPUActions.updatePurchaseOrderNo,
    hideAPUValidationErrMsg : ConfigureAPUActions.hideAPUValidationErrorMsg,
    getSubProductDetails: ConfigureAPUActions.getSubProductDetails
};

function mapStateToProps(state: any) {
    return {
        productData: state.configAPUData.payload.nonMsaConfigData,
        featuresMasterData: state.configAPUData.payload.featuresMasterData,
        isProductFetching: state.configAPUData.payload.isProductFetching,
        isProductFetchSuccess: state.configAPUData.payload.isProductFetchSuccess,
        isPODataFetching: state.configAPUData.payload.isContractDataFetching,
        isPODataSuccess: state.configAPUData.payload.isContractDataSuccess,
        purchaseOrders: state.configAPUData.payload.purchaseOrders,
        showAPUValidationErrorMsg: state.configAPUData.payload.showAPUValidationErrorMsg,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NonMSACustomerPO);
